// extracted by mini-css-extract-plugin
export default {"container":"m1-z","heading":"n1-z","links":"o1-z","copy":"p1-z","subCopy":"q1-z","linksLeft":"r1-z","linksCenter":"s1-z","linksRight":"t1-z","link":"u1-z","onlyLink":"v1-z"};